import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberGoogleScholar } from "./routeType";

const { key, getPath } = getApi("members.googleScholar.put");

type IExtractedRouteType =
  IMemberGoogleScholar["googleScholarDataSingleUpdate"];

export type IPutMemberGoogleScholar = IPickMutation<IExtractedRouteType>;

const putMemberGoogleScholar: Fetcher<
  IPutMemberGoogleScholar["response"],
  IPutMemberGoogleScholar["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.put(getPath({ memberId }), data);
};

export const usePutMemberGoogleScholar = createQuery({
  queryKey: [key],
  fetcher: putMemberGoogleScholar,
});
